import React from "react";
import Navbar from "../components/common/Navbar";
import BlogCard from "../components/blogs/BlogCard";
import { sampleBlogs } from "../components/blogs/blogs";
import { Link } from "react-router-dom";
import "../styles/blogs.css";

const Blogs = () => {
  return (
    <div className="blogs_page">
      <Navbar />
      <section className="blogs-section">
        <div className="container blogs-shell">
          <div className="row justify-content-center text-center">
            <div className="col-lg-9" data-aos="fade-up">
              <p className="news-eyebrow ff_n">Blogs</p>
              <h1 className="news-title ff_s">
                Latest <span className="section-heading-accent">Blogs</span>
              </h1>
              <p className="news-subtitle ff_n">
                Insights, industry explainers, and creative technology updates
                from HKI Media.
              </p>
              <div className="news-divider" />
            </div>
          </div>

          <div className="row g-4 blogs-grid">
            {sampleBlogs && sampleBlogs.length > 0 ? (
              sampleBlogs.map((blog, index) => (
                <BlogCard key={blog.slug} blog={blog} index={index} />
              ))
            ) : (
              <div className="col-12">
                <div className="blogs-empty text-center">
                  <h2 className="ff_s">No blogs published yet</h2>
                  <Link to="/" className="blogs-card-link ff_n">
                    Return to Homepage
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blogs;
